import React from "react";
import Spinner from "../Spinner/Spinner";
import Rotate from "../Table/Rotate";
import { cn } from "@/shared/utils/cn";

interface PosCartOrderButtonProps {
  isDisabled: boolean;
  isPending: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  buttonType?: "button" | "submit";
}

const PosCartOrderButton = ({
  isDisabled,
  isPending,
  onClick,
  children,
  buttonType = "button",
}: PosCartOrderButtonProps) => {
  return (
    <button
      onClick={() => {
        if (isPending) return;
        onClick?.();
      }}
      className={cn(
        "rounded-[0.5rem] w-full text-white cursor-pointer",
        isDisabled ? "bg-disabled" : "bg-primary"
      )}
      disabled={buttonType === "submit" ? isDisabled : false}
      type={buttonType}
    >
      <div className="flex w-full items-center justify-center">
        <h3 className={cn("m-0 font-bold text-white p-6 text-4xl")}>
          {children}
        </h3>
        {isPending ? (
          <Spinner color="var(--white)" size="0.2rem" />
        ) : (
          <Rotate
            variants="arrow"
            className={cn("fill-white rotate-270 size-10")}
          />
        )}
      </div>
    </button>
  );
};

export default PosCartOrderButton;
